<template>
  <v-dialog v-model="dialog" width="1200" scrollable>
    <v-card>
      <v-card-title> Informazioni Specie </v-card-title>
      <v-card-text>
        <v-img width="1200" height="200" :src="info_img_src">
          <v-row class="ma-6" justify="end" align="center">
            <v-btn icon color="grey" @click="$refs.input.click()"
              ><v-icon>mdi-camera</v-icon></v-btn
            >
          </v-row>
          <input
            type="file"
            style="display: none"
            @change="onFileChange($event)"
            ref="input"
          />
        </v-img>
        <v-divider class="my-4" />
        <v-textarea
          v-model="info_generali"
          rows="5"
          label="Informazioni generali"
          outlined
        >
        </v-textarea>
        <v-textarea v-model="info_rinvaso" rows="5" label="Rinvaso" outlined>
        </v-textarea>
        <v-textarea
          v-model="info_esposizione"
          rows="5"
          label="Esposizione"
          outlined
        >
        </v-textarea>
        <v-textarea
          v-model="info_irrigazione"
          rows="5"
          label="Irrigazione"
          outlined
        >
        </v-textarea>
        <v-textarea
          v-model="info_manutenzione"
          rows="5"
          label="Manutenzione"
          outlined
        >
        </v-textarea>
        <v-textarea v-model="info_malattie" rows="5" label="Malattie" outlined>
        </v-textarea>
        <v-textarea
          v-model="info_curiosita"
          rows="5"
          label="Curiosità"
          outlined
        >
        </v-textarea>
        <v-textarea
          v-model="info_esperti"
          rows="5"
          label="Per Esperti"
          outlined
        >
        </v-textarea>
        <InfoSerie
          v-for="serie in specie.series"
          :key="serie.id"
          :serie="serie"
          :id_specie="specie.id"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <info-preview :id_specie="id_specie" :all_info="all_info" />
        <v-btn text color="grey" @click="close()">chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import InfoPreview from "./info_preview.vue";
import InfoSerie from "./informazioni_serie.vue";
export default {
  components: {
    InfoPreview,
    InfoSerie,
  },
  props: {
    id_specie: String,
  },
  created() {
    this.debounce_info_generali = _.debounce(this.send_info_generali, 2000);
    this.debounce_info_rinvaso = _.debounce(this.send_info_rinvaso, 2000);
    this.debounce_info_esposizione = _.debounce(
      this.send_info_esposizione,
      2000
    );
    this.debounce_info_irrigazione = _.debounce(
      this.send_info_irrigazione,
      2000
    );
    this.debounce_info_manutenzione = _.debounce(
      this.send_info_manutenzione,
      2000
    );
    this.debounce_info_malattie = _.debounce(this.send_info_malattie, 2000);
    this.debounce_info_curiosita = _.debounce(this.send_info_curiosita, 2000);
    this.debounce_info_esperti = _.debounce(this.send_info_esperti, 2000);
  },
  data() {
    return {
      dialog: false,
      info_generali: "",
      info_rinvaso: "",
      info_esposizione: "",
      info_irrigazione: "",
      info_manutenzione: "",
      info_malattie: "",
      info_curiosita: "",
      info_esperti: "",
      all_info: null,
      file: null,
      md5: null,
      edit_catg: null,
      disable_watch: true,
    };
  },
  watch: {
    info_generali: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_generali";
      this.debounce_info_generali();
    },
    info_rinvaso: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_rinvaso";
      this.debounce_info_rinvaso();
    },
    info_esposizione: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_esposizione";
      this.debounce_info_esposizione();
    },
    info_irrigazione: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_irrigazione";
      this.debounce_info_irrigazione();
    },
    info_malattie: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_malattie";
      this.debounce_info_malattie();
    },
    info_manutenzione: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_manutenzione";
      this.debounce_info_manutenzione();
    },
    info_curiosita: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_curiosita";
      this.debounce_info_curiosita();
    },
    info_esperti: function () {
      if (this.disable_watch) {
        return;
      }
      this.edit_catg = "info_esperti";
      this.debounce_info_esperti();
    },
  },
  mounted() {},
  computed: {
    specie() {
      return this.$store.getters.get_specie_by_id(this.id_specie);
    },
    info_img_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/info_img?md5=" +
        this.md5
      );
    },
  },
  methods: {
    open() {
      this.disable_watch = true;
      this.$store
        .dispatch("fetch_info_specie_by_id", { id_specie: this.id_specie })
        .then((res) => {
          this.all_info = res;
          this.info_generali = res.info_generali;
          this.info_rinvaso = res.info_rinvaso;
          this.info_irrigazione = res.info_irrigazione;
          this.info_esposizione = res.info_esposizione;
          this.info_malattie = res.info_malattie;
          this.info_manutenzione = res.info_manutenzione;
          this.info_curiosita = res.info_curiosita;
          this.info_esperti = res.info_esperti;
          this.md5 = res.info_img_md5;
          this.dialog = true;
          setTimeout(() => {
            this.disable_watch = false;
          }, 2000);
        });
    },
    close() {
      this.dialog = false;
    },
    send_info_generali() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_generali,
      });
    },
    send_info_rinvaso() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_rinvaso,
      });
    },
    send_info_irrigazione() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_irrigazione,
      });
    },
    send_info_esposizione() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_esposizione,
      });
    },
    send_info_malattie() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_malattie,
      });
    },
    send_info_manutenzione() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_manutenzione,
      });
    },
    send_info_curiosita() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_curiosita,
      });
    },
    send_info_esperti() {
      this.$store.dispatch("send_specie_info", {
        id_specie: this.id_specie,
        categoria: this.edit_catg,
        text: this.info_esperti,
      });
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      this.invia_img();
    },
    invia_img() {
      let formData = new FormData();
      formData.append("file", this.file);
      this.$store
        .dispatch("send_specie_info_img", {
          id_specie: this.id_specie,
          formData: formData,
        })
        .then((res) => {
          this.md5 = res.data.md5;
        })
        .finally(() => {
          this.file = null;
        });
    },
  },
};
</script>